export default {
  name: 'CentralModalFrame',

  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  

  data() {
    return {};
  },

  computed: {},

  methods: {
    closeModal() {
      this.$EventBus.$emit('CentralModalFrame/CLOSE_CENTER_MODAL');
      this.onclose();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Help/CentralModalFrame/component.js